import {Component, HostListener, OnInit} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

import { FormsBuilderPolishedItemComponent } from './forms-builder-polished-item/forms-builder-polished-item.component';
import { FormsBuilderPolishedConfirmComponent } from './forms-builder-polished-confirm/forms-builder-polished-confirm.component';
import { FormsBuilderPolishedPreviewComponent } from './forms-builder-polished-preview/forms-builder-polished-preview.component';
import { FormsBuilderPolishedFormCreationComponent } from './forms-builder-polished-form-creation/forms-builder-polished-form-creation.component';
import { FormsBuilderPolishedService } from './services/forms-builder-polished.service';
import { FormsGlobals} from '../../../models/forms/forms.enum';
import { FormsService } from '../forms.service';
import {FormMasterItemConfigurationModel} from '../../../models/forms/form-master-item-configuration.model';
import {FormItemConfigurationModel} from '../../../models/forms/form-item-configuration.model';
import {FormParagraphConfigurationModel} from '../../../models/forms/form-paragraph-configuration.model';
import {FormVersionConfigurationModel} from '../../../models/forms/form-version-configuration.model';
import {FormConfigurationModel} from '../../../models/forms/form-configuration.model';
import {FormsConstants} from '../models/forms-constants';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service'; 
import {
  ProcedureFormMismatchDialogComponent
} from '../../../dialog/procedure-form-mismatch-dialog/procedure-form-mismatch-dialog.component';

@Component({
  selector: 'app-forms-builder-polished',
  templateUrl: './forms-builder-polished.component.html',
  styleUrls: ['./forms-builder-polished.component.scss']
})
export class FormsBuilderPolishedComponent implements OnInit {
  TDOCID: number = 0;
  isSearchingForForms: boolean = false;
  isLoading: boolean = false;
  formIsEditable: boolean = false;
  fetchCfgFormSubscription: any;
  searchFormSubscription: any;
  canClickItems: boolean = true;
  formSearchKeyword: string = '';

  cfgFormPreviewSelectListIsLoading: boolean = false;
  cfgFormIsLoading: boolean = false;
  connectedDragDropParagraphs: any[];

  selectedCfgForm: FormConfigurationModel;
  selectedCfgFormVersion: FormVersionConfigurationModel;
  selectedCfgFormParagraph: FormParagraphConfigurationModel;
  selectedParagraphOrganizer: any[] = null;
  selectedCfgFormPreviewId: string;
  selectedParagraphId: string;
  selectedVersionId: string;

  activeFormVersionStatus: string;
  activeParagraphOrientation: string;
  activeParagraphItemLayout: string;

  validValues: any[] = [];
  actionList: any[] = [];
  formSearchResults: any[] = null;
  cfgFormCategoryList: any[] = [];
  cfgFormDataSourceList: any[] = [];
  cfgFormItemLayoutList: any[] = [];
  cfgFormPreviewSelectList: any[] = [];
  cfgFormVersionStatusList: any[] = [];
  cfgFormItemTypeList: any[] = [];
  cfgFormParagraphOrientationList: any[] = [];

  guidList: string[] = [];
  categoryEnums: EnumValidValueItemModel[] = [];
  customEnums: EnumValidValueItemModel[] = [];

  isShiftPressed: boolean = false;

  @HostListener('document:keydown', ['$event']) onKeyDownHandler(event: KeyboardEvent) {
    this.isShiftPressed = event.shiftKey;
  }

  @HostListener('document:keyup', ['$event']) onKeyUpHandler(event: KeyboardEvent) {
    this.isShiftPressed = event.shiftKey;
  }

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private staticDataService: StaticDataService,
    private builderService: FormsBuilderPolishedService,
    private formsService: FormsService,
    private globals: FormsGlobals,
  ) { }

  ngOnInit() {
    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    }
  }

  setupEnums() {
    this.categoryEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFormCategory');
    this.customEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCustomForm');

    this.setupStatusList();
    this.setupParagraphOrientationList();
    this.setupItemLayoutList();
    this.setupItemTypeList();
    // this.setupFormCategories();
    this.setupDataSources();
    this.init();
  }

  searchForForm() {
    let keyword: string = this.formSearchKeyword;

    keyword = keyword.trim();

    this.isSearchingForForms = true;
    if (this.searchFormSubscription) {
      this.searchFormSubscription.unsubscribe();
    }

    if (!keyword) {
      this.formSearchResults = null;
      this.isSearchingForForms = false;
      return;
    }

    this.searchFormSubscription = this.builderService.searchForFormByKeyword(keyword)
      .subscribe((response) => {
        this.searchFormSubscription = false;
        this.isSearchingForForms = false;
        this.formSearchResults = response.sort((a, b) => {
          const keywordIndexA = a.DFormName.toLowerCase().indexOf(keyword.toLowerCase());
          const keywordIndexB = b.DFormName.toLowerCase().indexOf(keyword.toLowerCase());
          return keywordIndexA - keywordIndexB;
        });
      }, err => {
        this.searchFormSubscription = false;
        this.isSearchingForForms = false;
        this.showMessage('Error', 'Error search for form');
        console.log(err);
      });
  }

  clearChanges() {
    this.selectedCfgFormPreviewId = this.selectedCfgForm.DFormId;
    this.isLoading = true;
    this.fetchCfgForm()
      .then((result: FormConfigurationModel) => {
        this.selectedCfgForm = result;
        this.formIsEditable = false;
        this.cfgFormIsLoading = false;
        this.selectedVersionId = null;
        this.selectedCfgFormVersion = null;
        this.activeParagraphOrientation = null;
        this.selectedCfgFormParagraph = null;
        this.activeParagraphItemLayout = null;
        this.selectedParagraphOrganizer = null;
        this.connectedDragDropParagraphs = null;
        this.isLoading = false;
      }, err => {
        this.showMessage('Error', 'Something went wrong');
        this.isLoading = false;
      });
  }

  dropEventOnRow(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.selectedParagraphOrganizer, event.previousIndex, event.currentIndex);
    this.selectedParagraphOrganizer.forEach((row, i) => {
      row.forEach(item => {
        item.ParagraphRow = i;
      });
    });
  }

  paragraphReOrderEvent(event: CdkDragDrop<any[]>, paragraphItems) {
    moveItemInArray(paragraphItems, event.previousIndex, event.currentIndex);
    paragraphItems.forEach((paragraphItem, i) => {
      paragraphItem.ParagraphOrder = i;
    });
  }

  setupDataSources() {
    this.cfgFormDataSourceList = [
      { name: 'Generic', id: this.globals.FORM_DATA_SOURCE_GENERIC },
      { name: 'Custom', id: this.globals.FORM_DATA_SOURCE_CUSTOM },
    ];
  }

  selectCfgFormCategory(category: EnumValidValueItemModel) {
    this.selectedCfgForm.enumFormCategoryID = category.ValidValueItemId;
  }

  selectCfgFormDataSource(source) {
    this.selectedCfgForm.enumFormDataSourceID = source.id;
  }

  setupItemTypeList() {
    this.cfgFormItemTypeList = FormsConstants.cfgFormItemTypeList;
    this.organizeItemTypeList();
  }

  setupStatusList() {
    this.cfgFormVersionStatusList = [
      { name: 'Approved', id: this.globals.FORM_STATUS_APPROVED },
      { name: 'Draft', id: this.globals.FORM_STATUS_DRAFT },
      { name: 'Ready for review', id: this.globals.FORM_STATUS_READY_FOR_REVIEW },
      { name: 'In review', id: this.globals.FORM_STATUS_IN_REVIEW }
    ];
  }

  organizeItemTypeList() {
    this.cfgFormItemTypeList = this.cfgFormItemTypeList.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
      if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
      return 0;
    });
  }

  getItemLabel(cfgItem: FormItemConfigurationModel) {
    const itemLabel = this.cfgFormItemTypeList.find(itemType => {
      return itemType.id === cfgItem.enumFormControlID;
    });
    if (itemLabel) { return itemLabel; }
    return { name: '', icon: '' };
  }

  setupParagraphOrientationList() {
    this.cfgFormParagraphOrientationList = [
      { name: 'Horizontal', id: this.globals.PARAGRAPH_LAYOUT_HORIZONTAL },
      { name: 'Vertical', id: this.globals.PARAGRAPH_LAYOUT_VERTICAL },
    ];
  }

  setupItemLayoutList() {
    this.cfgFormItemLayoutList = [
      { name: 'Side by side', id: this.globals.ITEM_LAYOUT_SBS },
      { name: 'Two line', id: this.globals.ITEM_LAYOUT_TWO_LINE },
    ];
  }

  init() {
    this.setupAllFieldsForItemConfig();
    this.cfgFormPreviewSelectListIsLoading = true;

    const promises = [
      this.fetchFormList(),
      this.getNewGuids(1)
    ];
    Promise.all(promises).then((results: any[]) => {
      this.cfgFormPreviewSelectList = results[0];
      this.cfgFormPreviewSelectList = this.cfgFormPreviewSelectList.sort((a, b) => {
        if (a.DFormName.toLowerCase() < b.DFormName.toLowerCase()) { return -1; }
        if (a.DFormName.toLowerCase() > b.DFormName.toLowerCase()) { return 1; }
        return 0;
      });
      this.cfgFormPreviewSelectListIsLoading = false;
    });

    this.fetchFormList()
      .then((results: any[]) => {
      }, err => {
        this.cfgFormPreviewSelectListIsLoading = false;
      });
  }

  fetchFormList() {
    const promise = new Promise((resolve, reject) => {
      this.builderService.getCfgFormSimpleList()
        .subscribe(response => {
          // this.selectedCfgForm = response[25];
          resolve(response);
        }, err => {
          console.log('err', err);
          reject(err);
        });
    });
    return promise;
  }

  fetchCfgForm() {
    this.selectedCfgFormVersion = null;
    this.activeFormVersionStatus = null;
    const promise = new Promise((resolve, reject) => {

      if (this.fetchCfgFormSubscription) {
        this.fetchCfgFormSubscription.unsubscribe();
      }

      this.fetchCfgFormSubscription = this.formsService.getCfgDForm(this.selectedCfgFormPreviewId)
        .subscribe(response => {
          this.fetchCfgFormSubscription = false;
          if (response) {
            resolve(response);
          } else {
            reject('no response');
          }
        }, err => {
          this.fetchCfgFormSubscription = false;
          reject(err);
        });
    });
    return promise;
  }

  createAndSelectNewCfgForm(newName: string) {
    const promise = new Promise((resolve, reject) => {
      if (this.fetchCfgFormSubscription) {
        this.fetchCfgFormSubscription.unsubscribe();
        this.fetchCfgFormSubscription = false;
        this.cfgFormIsLoading = false;
      }

      this.selectedVersionId = null;
      this.selectedCfgForm = null;
      this.selectedCfgFormPreviewId = null;
      this.selectedCfgFormVersion = null;
      this.activeParagraphOrientation = null;
      this.selectedCfgFormParagraph = null;
      this.activeParagraphItemLayout = null;
      this.selectedParagraphOrganizer = null;
      this.connectedDragDropParagraphs = null;

      const newForm = new FormConfigurationModel();
      newForm.cfgDFormVersions = [];
      newForm.TDOCID = this.TDOCID;
      newForm.DFormName = newName;

      this.getNewGuids(1).then((newGuid: string[]) => {
        newForm.DFormId = newGuid[0];
        newForm.xauditDeleted = false;
        this.selectedCfgForm = newForm;
        this.createNewCfgFormVersion()
          .then(_ => {
            resolve(null);
          }, err => {
            reject(err);
          });
      }, err => {
        this.showMessage('Error', 'Error creating form');
        console.log(err);
        reject(err);
      });
    });
    return promise;
  }

  selectCfgFormVersion(cfgVersion) {
    this.selectedCfgFormVersion = cfgVersion;
    this.selectedVersionId = this.selectedCfgFormVersion.DFormVersionId;
    if (cfgVersion.enumDFormBuildStatus) {
      this.activeFormVersionStatus = cfgVersion.enumDFormBuildStatus.ItemDisplayValue;
    }
    this.selectedCfgFormVersion.cfgDFormParagraphs = this.selectedCfgFormVersion.cfgDFormParagraphs.sort((a, b) => {
      return a.ParagraphOrder - b.ParagraphOrder;
    });
    this.selectedCfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
      paragraph.cfgDFormItems = paragraph.cfgDFormItems.filter(item => {
        return item.xauditDeleted == false;
      });
    });

    // if (this.selectedCfgForm.cfgDFormVersions) {
    //  var addFlag = true;
    //  this.selectedCfgForm.cfgDFormVersions.forEach(version => {
    //    if (version.DFormVersionId == cfgVersion) {
    //      addFlag = false;
    //    }
    //  });
    //  if (addFlag) {
    //    this.selectedCfgForm.cfgDFormVersions.push(cfgVersion);
    //  }
    // }

    this.selectedParagraphId = null;
    this.activeParagraphOrientation = null;
    this.activeParagraphItemLayout = null;
    this.selectedCfgFormParagraph = null;
    this.selectedParagraphOrganizer = null;
  }

  selectCfgFormVersionStatus(formVersionStatus) {
    this.activeFormVersionStatus = formVersionStatus.id;
    this.selectedCfgFormVersion.enumDFormBuildStatus = null;
    this.selectedCfgFormVersion.enumDFormBuildStatusID = formVersionStatus.id;
  }

  selectAndFetchCfgForm(selectedFormId: string) {
    this.formIsEditable = false;
    this.selectedCfgFormPreviewId = selectedFormId;
    this.selectedCfgForm = null;
    this.cfgFormIsLoading = true;
    this.selectedVersionId = null;
    this.selectedCfgFormVersion = null;
    this.activeParagraphOrientation = null;
    this.selectedCfgFormParagraph = null;
    this.activeParagraphItemLayout = null;
    this.selectedParagraphOrganizer = null;
    this.connectedDragDropParagraphs = null;
    this.fetchCfgForm()
      .then((result: FormConfigurationModel) => {
        this.cfgFormIsLoading = false;
        this.selectedCfgForm = result;
        this.selectedCfgForm.cfgDFormVersions = this.selectedCfgForm.cfgDFormVersions.filter(version => {
          return !version.xauditDeleted;
        });
        this.selectedCfgForm.cfgDFormVersions = this.selectedCfgForm.cfgDFormVersions.sort((a, b) => {
          return a.Version - b.Version;
        });
        this.selectedCfgForm.cfgDFormVersions.forEach(version => {
          version.cfgDFormParagraphs = version.cfgDFormParagraphs.filter(paragraph => {
            return !paragraph.xauditDeleted;
          });
        });
      }, err => {
        this.cfgFormIsLoading = false;
        this.showMessage('Error', 'Error getting form');
      });
  }

  createNewCfgFormVersion() {

    const promise = new Promise((resolve, reject) => {

      if (this.selectedParagraphOrganizer) {
        this.overwriteParagraphItems();
      }

      this.selectedParagraphId = null;
      this.activeParagraphOrientation = null;
      this.activeParagraphItemLayout = null;
      this.selectedCfgFormParagraph = null;
      this.selectedParagraphOrganizer = null;

      let versionNumber = 1;
      this.selectedCfgForm.cfgDFormVersions.forEach(version => {
        if (version.Version >= versionNumber) {
          versionNumber = version.Version + 1;
        }
      });

      const newVersion = new FormVersionConfigurationModel();
      newVersion.DFormId = this.selectedCfgForm.DFormId;

      this.getNewGuids(1).then((newGuid: string[]) => {
        newVersion.DFormVersionId = newGuid[0];
        newVersion.Version = versionNumber;
        newVersion.Revision = 1;
        newVersion.xauditDeleted = false;
        newVersion.cfgDFormParagraphs = [];
        this.selectedVersionId = newVersion.DFormVersionId;
        this.selectedCfgForm.cfgDFormVersions.push(newVersion);
        this.selectCfgFormVersion(newVersion);
        resolve(null);
      }, err => {
        console.log(err);
        reject(err);
      });

    });
    return promise;
  }

  resetAllVariables() {
    this.selectedCfgForm = null;
    this.selectedCfgFormVersion = null;
    this.activeFormVersionStatus = null;
    this.selectedParagraphId = null;
    this.selectedCfgFormPreviewId = null;
    this.activeParagraphOrientation = null;
    this.activeParagraphItemLayout = null;
    this.selectedCfgFormParagraph = null;
    this.selectedParagraphOrganizer = null;
    this.selectedVersionId = null;
    this.connectedDragDropParagraphs = null;
  }

  refresh() {
    this.confirm('Are you sure you want to discard all unsaved changes?')
      .then(result => {
        if (result) {
          this.resetAllVariables();
          this.init();
        }
      });
  }

  selectDFormParagraph(paragraph) {
    if (this.selectedParagraphOrganizer) {
      this.overwriteParagraphItems();
    }
    this.selectedParagraphId = paragraph.DFormParagraphId;
    this.selectedCfgFormParagraph = paragraph;
    this.organizeParagraph(this.selectedCfgFormParagraph);
    this.activeParagraphOrientation = this.selectedCfgFormParagraph.enumParagraphOrientationID;
    this.activeParagraphItemLayout = this.selectedCfgFormParagraph.enumItemLayoutID;
  }

  organizeParagraph(paragraph) {
    this.selectedParagraphOrganizer = [];
    const itemOrganizer = {};
    const paragraphClone = JSON.parse(JSON.stringify(paragraph));
    paragraphClone.cfgDFormItems = paragraph.cfgDFormItems.filter(item => {
      return item.xauditDeleted == false;
    });
    paragraphClone.cfgDFormItems.forEach(item => {
      if (itemOrganizer[item.ParagraphRow]) {
        itemOrganizer[item.ParagraphRow].push(item);
      } else {
        itemOrganizer[item.ParagraphRow] = [item];
      }
    });
    const itemArray = [];
    for (const i in itemOrganizer) {
      itemOrganizer[i] = itemOrganizer[i].sort((a, b) => {
        return a.ParagraphColumn - b.ParagraphColumn;
      });
      itemArray.push(itemOrganizer[i]);
    }
    this.selectedParagraphOrganizer = itemArray;
    this.connectedDragDropParagraphs = [];
    for (let i = 0; i < this.selectedParagraphOrganizer.length; i++) {
      this.connectedDragDropParagraphs.push(`paragraphRow${i}`);
    }
    this.connectedDragDropParagraphs.push('itemListDropList');
  }

  selectParagraphOrientation(orientationId) {
    this.selectedCfgFormParagraph.enumParagraphOrientationID = orientationId;
  }

  selectParagraphItemLayout(layoutId) {
    this.selectedCfgFormParagraph.enumItemLayoutID = layoutId;
  }

  createNewDFormParagraph() {
    const newParagraph = new FormParagraphConfigurationModel();
    newParagraph.DFormVersionId = this.selectedCfgFormVersion.DFormVersionId;
    newParagraph.xauditDeleted = false;
    newParagraph.cfgDFormItems = [];
    newParagraph.ParagraphName = 'New Paragraph';

    let lastOrder = 0;
    this.selectedCfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
      if (paragraph.ParagraphOrder > lastOrder) {
        lastOrder = paragraph.ParagraphOrder;
      }
    });

    lastOrder++;
    newParagraph.ParagraphOrder = lastOrder;

    this.getNewGuids(1).then((newGuid: string[]) => {
      newParagraph.DFormParagraphId = newGuid[0];
      this.selectedCfgFormVersion.cfgDFormParagraphs.push(newParagraph);
      this.selectDFormParagraph(newParagraph);
    }, err => {
      console.log(err);
    });

  }

  dropEventInRow(event: CdkDragDrop<any[]>, row, rowIndex) {
    if (event.previousContainer === event.container) {
      const itemToMove = event.container.data[event.currentIndex];
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      const itemToMove = event.previousContainer.data[event.previousIndex];
      if (itemToMove.icon) {
        this.addEmptyItemIntoRow(row, itemToMove, rowIndex);
      } else {
        transferArrayItem(event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex);
      }
    }
    this.formatFormItemsFromOrganizer();
  }

  formatFormItemsFromOrganizer() {
    for (let i = 0; i < this.selectedParagraphOrganizer.length; i++) {
      const row = this.selectedParagraphOrganizer[i];
      for (let j = 0; j < row.length; j++) {
        const item: FormItemConfigurationModel = row[j];
        item.ParagraphRow = i;
        item.ParagraphColumn = j;
        item.ItemOrder = j;
      }
    }
  }

  addEmptyItemIntoRow(row, itemType, rowIndex) {
    const newItem = new FormItemConfigurationModel();
    newItem.DFormParagraphId = this.selectedCfgFormParagraph.DFormParagraphId;
    newItem.enumFormControlID = itemType.id;
    newItem.xauditDeleted = false;
    newItem.DFormItemName = 'NEW ITEM';
    this.getNewGuids(1).then((newGuid: string[]) => {
      newItem.DFormItemId = newGuid[0];
      row.push(newItem);
      this.openItemDetailDetail(newItem, rowIndex, row.length - 1)
        .then(result => {
        }, err => {
          console.log(err);
        });
    }, err => {
      console.log(err);
    });
  }

  addParagraphRowToOrganizer() {
    this.selectedParagraphOrganizer.push([]);
    this.connectedDragDropParagraphs = [];
    for (let i = 0; i < this.selectedParagraphOrganizer.length; i++) {
      this.connectedDragDropParagraphs.push(`paragraphRow${i}`);
    }
    this.connectedDragDropParagraphs.push('itemListDropList');
  }

  returnAllItemsForForm() {
    const itemArray = [];
    if (this.selectedParagraphOrganizer) {
      this.overwriteParagraphItems();
    }
    this.selectedCfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
      paragraph.cfgDFormItems.forEach(item => {
        if (item.xauditDeleted === false) {
          itemArray.push(item);
        }
      });
    });
    return itemArray;
  }

  overwriteParagraphItems() {
    if (this.selectedCfgFormParagraph) {
      this.selectedCfgFormVersion.cfgDFormParagraphs.forEach((paragraph) => {
        if (paragraph.DFormParagraphId === this.selectedCfgFormParagraph.DFormParagraphId) {
          paragraph.cfgDFormItems = [];
          this.selectedParagraphOrganizer.forEach((row) => {
            row.forEach((item: FormItemConfigurationModel) => {
              if (item.xauditDeleted === true) {
                item.ParagraphColumn = 99999;
                item.ItemOrder = 99999;
              }
            });
            row = row.sort((a: FormItemConfigurationModel, b: FormItemConfigurationModel) => {
              return a.ItemOrder - b.ItemOrder;
            });
          });

          this.selectedParagraphOrganizer.forEach((row, i) => {
            row.forEach((item: FormItemConfigurationModel, j) => {
              item.ParagraphColumn = j;
              item.ParagraphRow = i;
              item.ItemOrder = j;
              paragraph.cfgDFormItems.push(item);
            });
          });
        }
      });
    }
  }

  getNewGuids(count: number) {
    const promise = new Promise((resolve, reject) => {
      if (this.guidList.length < count) {
        this.builderService.getNewGuids(500)
          .subscribe(response => {
            this.guidList = this.guidList.concat(response);
            resolve(this.guidList.splice(0, count));
          }, err => {
            reject(err);
          });
      } else {
        resolve(this.guidList.splice(0, count));
      }
    });
    return promise;
  }

  openPreview() {
    if (this.selectedParagraphOrganizer) {
      this.overwriteParagraphItems();
    }
    const dialogRef = this.dialog.open(FormsBuilderPolishedPreviewComponent, {
      width: '1500px',
      height: '95%',
      data: {
        cfgFormVersion: this.selectedCfgFormVersion
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      //
    });
  }

  confirm(message) {
    const promise = new Promise((resolve, reject) => {
      const dialogRef = this.dialog.open(FormsBuilderPolishedConfirmComponent, {
        width: '500px',
        height: '225px',
        data: {
          message
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        resolve(result);
      }, err => {
        reject(err);
      });
    });
    return promise;
  }

  openItemDetailDetail(item, rowIndex = -1, itemIndex = -1) {
    if (!this.canClickItems) { 
      return;
    }
    const promise = new Promise((resolve, reject) => {
      const dialogRef = this.dialog.open(FormsBuilderPolishedItemComponent, {
        width: '1000px',
        height: '750px',
        data: {
          cfgItem: item,
          otherItems: this.returnAllItemsForForm(),
          validValues: this.validValues,
          actionList: this.actionList,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.delete) {

          console.log('NEED TO REMOVE FROM selectedCfgForm', this.selectedCfgForm);

          if (rowIndex > -1 && itemIndex > -1) {
            this.selectedCfgForm.cfgDFormVersions.forEach(version => {
              if (version.DFormVersionId === this.selectedCfgFormVersion.DFormVersionId) {
                version.cfgDFormParagraphs.forEach(paragraph => {
                  paragraph.cfgDFormItems.forEach(paragraphItem => {
                    if (paragraphItem.DFormItemId === item.DFormItemId) {
                      console.log('REMOVED 1');
                      paragraphItem.xauditDeleted = true;
                      paragraphItem.ParagraphColumn = 99999;
                      paragraphItem.ItemOrder = 99999;
                    }
                  });
                });
              }
            });

            this.selectedCfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
              paragraph.cfgDFormItems.forEach(paragraphItem => {
                if (paragraphItem.DFormItemId === item.DFormItemId) {
                  console.log('REMOVED 2');
                  paragraphItem.xauditDeleted = true;
                  paragraphItem.ParagraphColumn = 99999;
                  paragraphItem.ItemOrder = 99999;
                }
              });
            });
            // this.selectedParagraphOrganizer[rowIndex].splice(itemIndex, 1);
            this.selectedCfgFormParagraph.cfgDFormItems.forEach((cfgItem: FormItemConfigurationModel) => {
              if (cfgItem.DFormItemId === item.DFormItemId) {
                console.log('REMOVED 3');
                cfgItem.xauditDeleted = true;
                cfgItem.ParagraphColumn = 99999;
                cfgItem.ItemOrder = 99999;
              }
            });
          }
          this.showMessage('Success', 'Item deleted');
          let index = 0;
          this.selectedCfgFormParagraph.cfgDFormItems.forEach((cfgItem: FormItemConfigurationModel) => {
            if (cfgItem.xauditDeleted === false) {
              cfgItem.ParagraphColumn = index;
              cfgItem.ItemOrder = index;
              index++;
            }
          });

          this.saveItem(item, this.selectedCfgForm);
          this.selectedCfgFormParagraph.cfgDFormItems = this.selectedCfgFormParagraph.cfgDFormItems.sort((a, b) => {
            return a.ItemOrder - b.ItemOrder;
          });

          index = 0;
          this.selectedCfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
            paragraph.cfgDFormItems.forEach(paragraphItem => {
              if (paragraphItem.xauditDeleted === false) {
                paragraphItem.ParagraphColumn = index;
                paragraphItem.ItemOrder = index;
                index++;
              }
            });
            paragraph.cfgDFormItems = paragraph.cfgDFormItems.sort((a, b) => {
              return a.ItemOrder - b.ItemOrder;
            });
          });

          this.organizeParagraph(this.selectedCfgFormParagraph);
          resolve(false);
        } else if (result) {

          this.selectedParagraphOrganizer[rowIndex][itemIndex] = JSON.parse(JSON.stringify(result.item));

          if (result.duplicate && result.duplicate === true) {
            this.duplicateItem(result.item, rowIndex);
          }
          resolve(item);
        }
      }, err => {
        reject(err);
      });
    });
    return promise;
  }

  duplicateItem(itemToDuplicate: FormItemConfigurationModel, rowIndex) {
    const newItem: FormItemConfigurationModel = JSON.parse(JSON.stringify(itemToDuplicate));
    newItem.cfgDFormMasterItem = null;
    newItem.DFormMasterItemId = null;
    this.getNewGuids(1).then((newGuid: string[]) => {
      newItem.DFormItemId = newGuid[0];
      newItem.DFormItemName += newGuid[0].slice(0, 5);
      this.selectedParagraphOrganizer[rowIndex].push(newItem);

    }, err => {
      console.log(err);
    });
  }

  createNewMasterItem(item: FormItemConfigurationModel, form: FormConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      const newMasterItem = new FormMasterItemConfigurationModel();
      this.getNewGuids(1).then((newGuid: string[]) => {
        newMasterItem.DFormMasterItemId = newGuid[0];
        newMasterItem.TDOCID = this.TDOCID;
        const randomString = newGuid.slice(0, 10);
        newMasterItem.DFormItemName = `${item.DFormItemName}-${form.DFormName}-${randomString}`;
        // if (newMasterItem.DFormItemName.length > 149) {
        //  let newName: string = newMasterItem.DFormItemName;
        //  let amountToRemove = newMasterItem.DFormItemName.length - 149;
        //  newName = newName.slice(amountToRemove, newMasterItem.DFormItemName.length);
        //  newMasterItem.DFormItemName = newName;
        // }
        newMasterItem.enumFormControlID = item.enumFormControlID;
        newMasterItem.Label = item.Label;
        newMasterItem.xauditDeleted = false;
        newMasterItem.xauditModifiedOn = new Date();
        newMasterItem.xauditCreatedOn = new Date();

        this.saveMasterItem(newMasterItem)
          .then((response: FormMasterItemConfigurationModel) => {
            resolve(response);
          }, err => {
            reject(err);
          });
      }, err => {
        reject(err);
      });
    });
    return promise;
  }

  replaceNamesForForms() {
    this.cfgFormPreviewSelectList.forEach(form => {
      if (form.DFormId === this.selectedCfgForm.DFormId) {
        form.DFormName = this.selectedCfgForm.DFormName;
      }
    });
  }

  filterOutAllDeletedObjects() {
    if (this.selectedCfgFormVersion) {
      this.selectedCfgFormVersion.cfgDFormParagraphs = this.selectedCfgFormVersion.cfgDFormParagraphs.filter(paragraph => {
        return paragraph.xauditDeleted === false;
      });
    }

    if (this.selectedCfgFormParagraph) {
      this.selectedCfgFormParagraph.cfgDFormItems = this.selectedCfgFormParagraph.cfgDFormItems.filter(item => {
        return item.xauditDeleted === false;
      });
    }
  }

  saveFormData() {

    this.isLoading = true;

    if (this.selectedParagraphOrganizer) {
      this.overwriteParagraphItems();
    }

    this.saveForm(this.selectedCfgForm).then(response => {
      this.replaceNamesForForms();
      if (this.selectedCfgFormVersion) {
        this.saveVersion(this.selectedCfgFormVersion).then(response => {
          const paragraphPromises = this.selectedCfgFormVersion.cfgDFormParagraphs.map(paragraph => {
            return this.saveParagraph(paragraph);
          });
          Promise.all(paragraphPromises).then(results => {
            const itemPromises = [];
            this.selectedCfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
              paragraph.cfgDFormItems.forEach(item => {
                itemPromises.push(this.saveItem(item, this.selectedCfgForm));
              });
            });
            Promise.all(itemPromises).then(results => {
              this.isLoading = false;
              this.showMessage('Success', 'Data saved');
              this.filterOutAllDeletedObjects();
            }, err => {
              this.isLoading = false;
              this.showMessage('Error', 'Error saving item');
              console.log('error saving items', err);
            });
          }, err => {
            this.isLoading = false;
            this.showMessage('Error', 'Error saving paragraph');
            console.log('error saving paragraphs', err);
          });
        }, err => {
          this.isLoading = false;
          this.showMessage('Error', 'Error saving version');
          console.log('error saving version', err);
        });
      } else {
        this.isLoading = false;
        this.showMessage('Success', 'Data saved');
      }
    }, err => {
      this.isLoading = false;
      if (err.error.Message === 'A custom form of this type already exists.') {
        this.showMessage('Error', err.error.Message);
      } else {
        this.showMessage('Error', 'Error saving form');
      }
    });
  }

  saveForm(form: FormConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      const formClone: FormConfigurationModel = JSON.parse(JSON.stringify(form));
      formClone.cfgDFormVersions = [];
      formClone.enumFormCategory = null;
      formClone.enumFormDataSource = null;
      formClone.enumCustomForm = null;
      this.builderService.saveCfgDForm(formClone)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  saveVersion(version: FormVersionConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      const versionClone: FormVersionConfigurationModel = JSON.parse(JSON.stringify(version));
      versionClone.cfgDFormParagraphs = [];
      versionClone.enumDFormBuildStatus = null;
      this.builderService.saveCfgFormVersion(versionClone)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  saveParagraph(paragraph: FormParagraphConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      const paragraphClone: FormParagraphConfigurationModel = JSON.parse(JSON.stringify(paragraph));
      paragraphClone.RepeatDFormItem = null;
      paragraphClone.cfgDFormItems = [];
      paragraphClone.enumParagraphOrientation = null;
      paragraphClone.enumItemLayout = null;
      this.builderService.saveCfgParagraph(paragraphClone)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  fetchAllActions() {
    const promise = new Promise((resolve, reject) => {
      this.builderService.getAllActions()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  fetchAllValidValues() {
    const promise = new Promise((resolve, reject) => {
      this.builderService.getAllValidValues()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  setupAllFieldsForItemConfig() {

    this.canClickItems = false;

    const promises = [
      this.fetchAllValidValues(),
      this.fetchAllActions(),
    ];

    Promise.all(promises).then((results: any[]) => {
      this.validValues = results[0];
      this.validValues = this.validValues.sort((a, b) => {
        if (a.ValidValueName.toLowerCase() < b.ValidValueName.toLowerCase()) { return -1; }
        if (a.ValidValueName.toLowerCase() > b.ValidValueName.toLowerCase()) { return 1; }
        return 0;
      });
      this.actionList = results[1];
      this.actionList = this.actionList.sort((a, b) => {
        if (a.ActionName.toLowerCase() < b.ActionName.toLowerCase()) { return -1; }
        if (a.ActionName.toLowerCase() > b.ActionName.toLowerCase()) { return 1; }
        return 0;
      });
      this.canClickItems = true;
    }, err => {
      this.canClickItems = true;
      this.showMessage('Error', 'Error fetching configurations. Please click the refresh button.');
      console.log(err);
    });

  }

  saveItem(item: FormItemConfigurationModel, form: FormConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      const itemClone: FormItemConfigurationModel = JSON.parse(JSON.stringify(item));
      itemClone.Calculation = null;
      itemClone.BeforeDisplayItemAction = null;
      itemClone.AfterUpdateItemAction = null;
      itemClone.ValidValue = null;
      itemClone.ChildDFormItems = [];
      itemClone.cfgDFormMasterItem = null;
      itemClone.enumFormControl = null;
      itemClone.enumLabelAligment = null;
      itemClone.enumPostLabelAligment = null;

      if (itemClone.DFormMasterItemId == null) {
        this.createNewMasterItem(itemClone, form)
          .then((newMasterItem: FormMasterItemConfigurationModel) => {
            item.DFormMasterItemId = newMasterItem.DFormMasterItemId;
            itemClone.DFormMasterItemId = newMasterItem.DFormMasterItemId;
            this.builderService.saveCfgItem(itemClone)
              .subscribe(response => {
                resolve(response);
              }, err => {
                reject(err);
              });
          }, err => {
            reject(err);
          });
      } else {
        this.builderService.saveCfgItem(itemClone)
          .subscribe(response => {
            resolve(response);
          }, err => {
            reject(err);
          });
      }
    });
    return promise;
  }

  saveMasterItem(masterItem: FormMasterItemConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      const masterClone: FormMasterItemConfigurationModel = JSON.parse(JSON.stringify(masterItem));
      masterItem.enumFormControl = null;
      this.builderService.saveCfgMasterItem(masterClone)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  deleteForm() {
    this.confirm('Are you sure you want to delete this form?').then(result => {
      if (!result) { return; }
      this.builderService.deleteCfgForm(this.selectedCfgForm.DFormId).subscribe((res) => {
        if (res.IsProcedureForms) {
          const config = new MatDialogConfig();
          config.panelClass = 'dialog';
          config.data = res;
          this.dialog.open(ProcedureFormMismatchDialogComponent, config);
        }

        const form = this.selectedCfgForm;
        this.cfgFormPreviewSelectList = this.cfgFormPreviewSelectList.filter(formPreview => {
          return formPreview.DFormId.toLowerCase() !== form.DFormId.toLowerCase();
        });
        this.isSearchingForForms = false;
        this.formSearchResults = null;
        this.formSearchKeyword = '';
        this.resetAllVariables();
        this.init();
        this.showMessage('Success', 'Form deleted');
      }, error => {
        this.resetAllVariables();
        this.init();
        this.showMessage('Success', 'An error occurred while attempting to delete the form.');
      });
    });
  }

  deleteVersion() {
    this.confirm('Are you sure you want to delete this version?').then(result => {
      if (!result) { return; }
      let version;
      this.selectedCfgForm.cfgDFormVersions.forEach((cfgVersion, i) => {
        if (cfgVersion.DFormVersionId === this.selectedCfgFormVersion.DFormVersionId) {
          version = cfgVersion;
          this.selectedCfgForm.cfgDFormVersions.splice(i, 1);
        }
      });
      version.xauditDeleted = true;
      this.saveVersion(version)
        .then(response => {
          this.selectedCfgFormVersion = null;
          this.activeFormVersionStatus = null;
          this.selectedParagraphId = null;
          this.activeParagraphOrientation = null;
          this.activeParagraphItemLayout = null;
          this.selectedCfgFormParagraph = null;
          this.selectedParagraphOrganizer = null;
          this.selectedVersionId = null;
          this.connectedDragDropParagraphs = null;
          this.showMessage('Success', 'Version deleted');
        }, err => {
          this.selectedCfgFormVersion = null;
          this.activeFormVersionStatus = null;
          this.selectedParagraphId = null;
          this.activeParagraphOrientation = null;
          this.activeParagraphItemLayout = null;
          this.selectedCfgFormParagraph = null;
          this.selectedParagraphOrganizer = null;
          this.selectedVersionId = null;
          this.connectedDragDropParagraphs = null;
          this.showMessage('Success', 'Version deleted');
        });
    });
  }

  deleteParagraph() {

    this.confirm('Are you sure you want to delete this paragraph?').then(result => {
      if (!result) { return; }
      let paragraph;
      this.selectedCfgFormVersion.cfgDFormParagraphs.forEach((cfgParagraph, i) => {
        if (cfgParagraph.DFormParagraphId === this.selectedCfgFormParagraph.DFormParagraphId) {
          paragraph = cfgParagraph;
          this.selectedCfgFormVersion.cfgDFormParagraphs.splice(i, 1);
        }
      });
      if (paragraph) {
        paragraph.xauditDeleted = true;
        this.saveParagraph(paragraph)
          .then(response => {
            this.selectedCfgFormParagraph = null;
            this.activeParagraphOrientation = null;
            this.activeParagraphItemLayout = null;
            this.selectedParagraphOrganizer = null;
            this.connectedDragDropParagraphs = null;
            this.showMessage('Success', 'Paragraph deleted');
          }, err => {
            this.selectedCfgFormParagraph = null;
            this.activeParagraphOrientation = null;
            this.activeParagraphItemLayout = null;
            this.selectedParagraphOrganizer = null;
            this.connectedDragDropParagraphs = null;
            this.showMessage('Success', 'Paragraph deleted');
          });
      } else {
        this.selectedCfgFormParagraph = null;
        this.activeParagraphOrientation = null;
        this.activeParagraphItemLayout = null;
        this.selectedParagraphOrganizer = null;
        this.connectedDragDropParagraphs = null;
      }
    });
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  saveDuplicatedForm(cfgForm: FormConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      this.builderService.saveDuplicatedCfgDForm(cfgForm)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  saveDuplicatedVersion(cfgVersion: FormVersionConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      this.builderService.saveDuplicateCfgVersion(cfgVersion)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  createNewFormButtonPressed() {
    this.selectedParagraphOrganizer = null;
    const dialogRef = this.dialog.open(FormsBuilderPolishedFormCreationComponent, {
      width: '500px',
      height: '450px',
      data: {
        mode: 'create'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.proceed) {
        this.isLoading = true;
        this.isSearchingForForms = false;
        this.formSearchResults = null;
        this.formSearchKeyword = '';
        if (result.mode === 'duplicate') {
          this.fetchCfgFormForDuplication(result.selectedForm.DFormId)
            .then((formToClone: FormConfigurationModel) => {
              this.duplicateAForm(formToClone)
                .then((cloneForm: FormConfigurationModel) => {
                  cloneForm.DFormName = result.DFormName;
                  this.saveDuplicatedForm(cloneForm)
                    .then((savedForm: FormConfigurationModel) => {
                      this.selectedCfgForm = savedForm;
                      this.showMessage('Success', 'Form duplicated');
                      this.formIsEditable = true;

                      this.selectedParagraphId = null;
                      this.activeParagraphOrientation = null;
                      this.activeParagraphItemLayout = null;
                      this.selectedCfgFormParagraph = null;
                      this.selectedParagraphOrganizer = null;
                      this.selectedVersionId = null;
                      this.activeFormVersionStatus = null;
                      this.selectedCfgFormVersion = null;

                      this.isLoading = false;
                    }, err => {
                      this.isLoading = false;
                      this.showMessage('Error', 'Error duplicating the form');
                      console.log('error', err);
                    });
                }, err => {
                  console.log('error', err);
                  this.showMessage('Error', 'Error duplicating the form');
                  this.isLoading = false;
                });
            }, err => {
              this.isLoading = false;
              this.showMessage('Error', 'Error duplicating the form');
              console.log('error', err);
            });
        } else {
          // create mode
          this.createAndSelectNewCfgForm(result.DFormName)
            .then(_ => {
              this.selectedParagraphId = null;
              this.activeParagraphOrientation = null;
              this.activeParagraphItemLayout = null;
              this.selectedCfgFormParagraph = null;
              this.selectedParagraphOrganizer = null;
              this.selectedVersionId = null;
              this.activeFormVersionStatus = null;
              this.selectedCfgFormVersion = null;
              this.isLoading = false;
              this.formIsEditable = true;
              this.showMessage('Success', 'Form created');
            }, err => {
              this.isLoading = false;
              this.showMessage('Error', 'Error creating the form');
            });
        }
      }

    });
  }

  editFormButtonPressed() {
    this.selectedParagraphOrganizer = null;
    const dialogRef = this.dialog.open(FormsBuilderPolishedFormCreationComponent, {
      width: '500px',
      height: '450px',
      data: {
        mode: 'edit',
        existingVersions: this.selectedCfgForm.cfgDFormVersions
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.proceed) {
        if (result.mode == 'copy') {
          const formToClone = this.selectedCfgForm;
          const versionID = result.versionID;
          const versionToClone = formToClone.cfgDFormVersions.find(v => v.DFormVersionId == versionID);
          const newVersion = new FormVersionConfigurationModel();
          this.isLoading = true;
          newVersion.DFormId = formToClone.DFormId;
          this.duplicateAVersion(versionToClone, newVersion)
            .then((clonedVersion: FormVersionConfigurationModel) => {
              clonedVersion.Version = 0;
              formToClone.cfgDFormVersions.forEach(v => {
                if (v.Version > clonedVersion.Version) {
                  clonedVersion.Version = v.Version;
                }
              });
              clonedVersion.Version += 1;
              this.saveDuplicatedVersion(clonedVersion)
                .then((savedClone: FormVersionConfigurationModel) => {
                  this.selectedVersionId = savedClone.DFormVersionId;
                  this.selectedCfgForm.cfgDFormVersions.push(savedClone);
                  this.selectCfgFormVersion(savedClone);
                  this.formIsEditable = true;

                  this.selectedParagraphId = null;
                  this.activeParagraphOrientation = null;
                  this.activeParagraphItemLayout = null;
                  this.selectedCfgFormParagraph = null;
                  this.selectedParagraphOrganizer = null;
                  this.isLoading = false;
                  this.showMessage('Success', 'Version created');
                }, err => {
                  this.isLoading = false;
                  this.formIsEditable = false;
                  this.showMessage('Error', 'Error creating the version');
                  console.log(err);
                });
            }, err => {
              this.isLoading = false;
              this.formIsEditable = false;
              this.showMessage('Error', 'Error creating the version');
              console.log(err);
            });
        } else if (result.mode === 'edit') {
          const formToClone = this.selectedCfgForm;
          const versionID = result.versionID;
          const versionToEdit = formToClone.cfgDFormVersions.find(v => v.DFormVersionId == versionID);
          versionToEdit.Revision += 1;
          this.selectedVersionId = versionToEdit.DFormVersionId;
          this.selectCfgFormVersion(versionToEdit);
          this.formIsEditable = true;
          this.selectedParagraphId = null;
          this.selectedCfgFormParagraph=null;
          this.activeParagraphOrientation = null;
          this.activeParagraphItemLayout = null;
          this.selectedCfgFormParagraph = null;
          this.selectedParagraphOrganizer = null;
        } else if (result.mode == 'create') {
          this.createNewCfgFormVersion()
            .then(_ => {
              this.selectedParagraphId = null;
              this.activeParagraphOrientation = null;
              this.activeParagraphItemLayout = null;
              this.selectedCfgFormParagraph = null;
              this.selectedParagraphOrganizer = null;
              this.activeFormVersionStatus = null;
              this.formIsEditable = true;
            });
        } else if (result.mode === 'delete') {
          this.deleteForm();
        }
      }
    });
  }

  fetchCfgFormForDuplication(formPreviewId) {
    const promise = new Promise((resolve, reject) => {
      this.formsService.getCfgDForm(formPreviewId)
        .subscribe(response => {
          this.fetchCfgFormSubscription = false;
          if (response) {
            resolve(response);
          } else {
            reject('no response');
          }
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  duplicateAForm(originalForm: FormConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      const newForm: FormConfigurationModel = new FormConfigurationModel();
      newForm.TDOCID = originalForm.TDOCID;
      newForm.enumFormCategoryID = originalForm.enumFormCategoryID;
      newForm.enumFormDataSourceID = originalForm.enumFormDataSourceID;
      newForm.enumCustomFormID = originalForm.enumCustomFormID;
      newForm.xauditDeleted = false;
      this.getNewGuids(1)
        .then((newGuid: string[]) => {
          newForm.DFormId = newGuid[0];
          this.duplicateAllVersionsForForm(originalForm)
            .then((duplicatedVersions: FormVersionConfigurationModel[]) => {
              newForm.cfgDFormVersions = duplicatedVersions;
              resolve(newForm);
            });
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  duplicateAllVersionsForForm(originalForm: FormConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      const arr = originalForm.cfgDFormVersions.map((version: FormVersionConfigurationModel) => {
        const newVersion: FormVersionConfigurationModel = new FormVersionConfigurationModel();
        newVersion.DFormId = originalForm.DFormId;
        return [version, newVersion];
      });
      const promises = arr.map((args) => this.duplicateAVersion(args[0], args[1]));
      Promise.all(promises).then((versionsResults: FormVersionConfigurationModel[]) => {
        resolve(versionsResults);
      }, err => {
        reject(err);
      });
    });
    return promise;
  }

  duplicateAVersion(originalVersion: FormVersionConfigurationModel, newVersion: FormVersionConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      newVersion.Version = originalVersion.Version;
      newVersion.Revision = originalVersion.Revision;
      newVersion.enumDFormBuildStatusID = originalVersion.enumDFormBuildStatusID;
      newVersion.DFormBuildStatusBy = originalVersion.DFormBuildStatusBy;
      newVersion.DFormBuildStatusOn = originalVersion.DFormBuildStatusOn;
      newVersion.xauditDeleted = originalVersion.xauditDeleted;
      this.getNewGuids(1)
        .then((newGuid: string[]) => {
          newVersion.DFormVersionId = newGuid[0];
          this.duplicateAllParagraphsForVersion(originalVersion.cfgDFormParagraphs, newVersion)
            .then((paragraphs: FormParagraphConfigurationModel[]) => {
              newVersion.cfgDFormParagraphs = paragraphs;
              resolve(newVersion);
            }, err => {
              reject(err);
            });
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  duplicateAllParagraphsForVersion(paragraphsToClone: FormParagraphConfigurationModel[], newVersion: FormVersionConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      const arr = paragraphsToClone.map((paragraph: FormParagraphConfigurationModel) => {
        const newParagraph: FormParagraphConfigurationModel = new FormParagraphConfigurationModel();
        newParagraph.DFormVersionId = newVersion.DFormVersionId;
        return [paragraph, newParagraph];
      });
      const promises = arr.map((args) => {
        return this.duplicateAParagraph(args[0], args[1]);
      });
      Promise.all(promises).then((paragraphs: FormParagraphConfigurationModel[]) => {
        resolve(paragraphs);
      }, err => {
        reject(err);
      });
    });
    return promise;
  }

  duplicateAParagraph(originalParagraph: FormParagraphConfigurationModel, newParagraph: FormParagraphConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      newParagraph.ParagraphName = originalParagraph.ParagraphName;
      newParagraph.isRepeting = originalParagraph.isRepeting;
      newParagraph.isFillForward = originalParagraph.isFillForward;
      newParagraph.enumParagraphOrientationID = originalParagraph.enumParagraphOrientationID;
      newParagraph.MaximumColumnCount = originalParagraph.MaximumColumnCount;
      newParagraph.MaximumRowCount = originalParagraph.MaximumRowCount;
      newParagraph.ParagraphIndent = originalParagraph.ParagraphIndent;
      newParagraph.enumItemLayoutID = originalParagraph.enumItemLayoutID;
      newParagraph.isFirstRowHeader = originalParagraph.isFirstRowHeader;
      newParagraph.HeaderHeight = originalParagraph.HeaderHeight;
      newParagraph.ParagraphOrder = originalParagraph.ParagraphOrder;
      newParagraph.PageBreakAfter = originalParagraph.PageBreakAfter;
      newParagraph.xauditDeleted = originalParagraph.xauditDeleted;
      this.getNewGuids(1)
        .then((newGuid: string[]) => {
          newParagraph.DFormParagraphId = newGuid[0];
          let hasRepeatItem: boolean = false;
          const promises = [];
          promises.push(this.duplicateAllItems(originalParagraph.cfgDFormItems, newParagraph));
          if (originalParagraph.RepeatDFormItemId) {
            hasRepeatItem = true;
            const newItem = new FormItemConfigurationModel();
            newItem.DFormParagraphId = newParagraph.DFormParagraphId;
            promises.push(this.duplicateAItem(originalParagraph.RepeatDFormItem, newItem));
          }
          Promise.all(promises).then((promiseResults: any[]) => {
            newParagraph.cfgDFormItems = promiseResults[0];
            if (hasRepeatItem) {
              newParagraph.RepeatDFormItem = promiseResults[1];
              newParagraph.RepeatDFormItemId = newParagraph.RepeatDFormItem.DFormItemId;
            }
            resolve(newParagraph);
          }, err => {
            reject(err);
          });
        }, err => {
          console.log(err);
        });
    });
    return promise;
  }

  duplicateAllItems(itemsToClone: FormItemConfigurationModel[], newParagraph: FormParagraphConfigurationModel) {
    const promise = new Promise((resolve, reject) => {

      const arr = itemsToClone.map((item: FormItemConfigurationModel) => {
        const newItem: FormItemConfigurationModel = new FormItemConfigurationModel();
        newItem.DFormParagraphId = newParagraph.DFormParagraphId;
        return [item, newItem];
      });

      const promises = arr.map((args) => {
        return this.duplicateAItem(args[0], args[1]);
      });

      Promise.all(promises).then((itemGroups: any[]) => {
        itemGroups.forEach((itemGroup: any[]) => {
          const originalItem: FormItemConfigurationModel = itemGroup[0];
          const newItem: FormItemConfigurationModel = itemGroup[1];
          if (originalItem.ParentDFormItemId) {
            newItem.ParentDFormItemId = this.findNewItemParentId(originalItem.ParentDFormItemId, itemGroups);
          }
        });
        const finalItemArr = itemGroups.map((itemGroup: any[]) => {
          return itemGroup[1];
        });
        resolve(finalItemArr);
      }, err => {
        reject(err);
      });
    });
    return promise;
  }

  findNewItemParentId(parentId: string, itemGroups: any[]) {
    let foundParentIdString;
    itemGroups.forEach(itemGroup => {
      const originalItem: FormItemConfigurationModel = itemGroup[0];
      const newItem: FormItemConfigurationModel = itemGroup[1];
      if (originalItem.DFormItemId === parentId) {
        foundParentIdString = newItem.DFormItemId;
      }
    });
    return foundParentIdString;
  }

  duplicateAItem(originalItem: FormItemConfigurationModel, newItem: FormItemConfigurationModel) {
    const promise = new Promise((resolve, reject) => {
      newItem.DFormItemName = originalItem.DFormItemName;
      newItem.HasChildren = originalItem.HasChildren;
      newItem.enumFormControlID = originalItem.enumFormControlID;
      newItem.ItemOrder = originalItem.ItemOrder;
      newItem.ParagraphRow = originalItem.ParagraphRow;
      newItem.ParagraphColumn = originalItem.ParagraphColumn;
      newItem.ParagraphRowHeight = originalItem.ParagraphRowHeight;
      newItem.ParagraphColumnWidth = originalItem.ParagraphColumnWidth;
      newItem.FormControlColumnSpan = originalItem.FormControlColumnSpan;
      newItem.Label = originalItem.Label;
      newItem.LabelWidth = originalItem.LabelWidth;
      newItem.PostLabel = originalItem.PostLabel;
      newItem.ValidValueId = originalItem.ValidValueId;
      newItem.BeforeDisplay_ItemActionId = originalItem.BeforeDisplay_ItemActionId;
      newItem.AfterUpdate_ItemActionId = originalItem.AfterUpdate_ItemActionId;
      newItem.DefaultValue = originalItem.DefaultValue;
      newItem.isBreakAfterItem = originalItem.isBreakAfterItem;
      newItem.CalculationID = originalItem.CalculationID;
      newItem.isNoteEnabled = originalItem.isNoteEnabled;
      newItem.isDocumentEnabled = originalItem.isDocumentEnabled;
      newItem.enumLabelAligmentID = originalItem.enumLabelAligmentID;
      newItem.enumPostLabelAligmentID = originalItem.enumPostLabelAligmentID;
      newItem.xauditDeleted = originalItem.xauditDeleted;

      const newMasterItem: FormMasterItemConfigurationModel = new FormMasterItemConfigurationModel();
      newMasterItem.enumFormControlID = originalItem.cfgDFormMasterItem.enumFormControlID;
      newMasterItem.Label = originalItem.cfgDFormMasterItem.Label;
      newMasterItem.TDOCID = originalItem.cfgDFormMasterItem.TDOCID;
      newMasterItem.xauditDeleted = originalItem.cfgDFormMasterItem.xauditDeleted;

      this.getNewGuids(2)
        .then((newGuids: string[]) => {
          newItem.DFormItemId = newGuids[0];
          newMasterItem.DFormMasterItemId = newGuids[1];
          newMasterItem.DFormItemName = originalItem.cfgDFormMasterItem.DFormItemName + 'CLONE' + newItem.DFormItemId.slice(0, 5);
          if (newMasterItem.DFormItemName.length > 149) {
            let newName: string = newMasterItem.DFormItemName;
            const amountToRemove = newMasterItem.DFormItemName.length - 149;
            newName = newName.slice(amountToRemove, newMasterItem.DFormItemName.length);
            newMasterItem.DFormItemName = newName;
          }
          newItem.DFormMasterItemId = newMasterItem.DFormMasterItemId;
          newItem.cfgDFormMasterItem = newMasterItem;
          resolve([originalItem, newItem]);
        });
    });
    return promise;
  }

  getCategoryValue(enumFormCategoryID: string) {
    if (this.categoryEnums) {
      const enu = this.categoryEnums.find(p => p.ValidValueItemId === enumFormCategoryID);
      if (enu) {
        return enu;
      }
    }

    return null;
  }

  getCustomValue(enumFormCategoryID: string) {
    if (this.customEnums) {
      const enu = this.customEnums.find(p => p.ValidValueItemId === enumFormCategoryID);
      if (enu) {
        return enu;
      }
    }

    return null;
  }

  getDataSourceValue(enumDataSourceID: string) {
    if (this.cfgFormDataSourceList) {
      const enu = this.cfgFormDataSourceList.find(p => p.id === enumDataSourceID);
      if (enu) {
        return enu;
      }
    }

    return null;
  }

  getVersion(selectedVersionId: string) {
    if (this.selectedCfgForm && this.selectedCfgForm.cfgDFormVersions) {
      const ver = this.selectedCfgForm.cfgDFormVersions.find(p => p.DFormVersionId === selectedVersionId);
      if (ver) {
        return ver;
      }
    }

    return null;
  }

  getVersionStatus(activeFormVersionStatus: string) {
    if (this.cfgFormVersionStatusList) {
      const enu = this.cfgFormVersionStatusList.find(p => p.id.toLowerCase() === activeFormVersionStatus);
      if (enu) {
        return enu;
      }
    }

    return null;
  }
}
